var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorDesktop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 216,
    viewBox: "0 0 226 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.859 77.99V203.84C203.859 206.377 202.852 208.809 201.058 210.603C199.264 212.397 196.832 213.404 194.295 213.404H31.7103C29.1738 213.404 26.7412 212.397 24.9477 210.603C23.1541 208.809 22.1465 206.377 22.1465 203.84V77.99",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.496 8.31749C205.706 6.72376 204.487 5.38183 202.977 4.44249C201.467 3.50315 199.724 3.00361 197.945 3H28.0537C26.2781 3.00095 24.5378 3.4962 23.0277 4.43029C21.5176 5.36438 20.2974 6.70043 19.5037 8.28879L3.01562 41.2553H222.984L206.496 8.31749Z",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.984 50.8192C223.179 56.4483 221.633 62.0006 218.557 66.7188C215.48 71.4369 211.024 75.0911 205.794 77.183C200.564 79.2748 194.817 79.7024 189.335 78.4074C183.854 77.1124 178.905 74.1579 175.164 69.9469C172.068 75.1851 167.78 79.6194 162.649 82.8901C157.518 86.1607 151.688 88.1754 145.632 88.7707C139.576 89.366 133.466 88.5252 127.796 86.3164C122.126 84.1076 117.057 80.5931 113 76.0582C108.941 80.5912 103.872 84.104 98.2023 86.3116C92.5327 88.5192 86.4227 89.3594 80.3676 88.7641C74.3126 88.1689 68.4831 86.1549 63.352 82.8855C58.2208 79.6161 53.9325 75.1834 50.8347 69.9469C47.0917 74.1524 42.1434 77.1018 36.6637 78.3936C31.184 79.6853 25.4393 79.2566 20.2121 77.1657C14.9849 75.0748 10.5292 71.4234 7.45202 66.7089C4.37483 61.9944 2.82568 56.4459 3.01559 50.8192V41.2554H222.984V50.8192Z",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.835 69.9753V41.2838L60.3988 3.02852",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.004 76.1439V41.2838V3.02852",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.164 69.9753V41.2838L165.601 3.02852",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3023 125.627C77.7198 125.627 78.1279 125.75 78.475 125.982C78.8221 126.214 79.0927 126.544 79.2524 126.93C79.4122 127.315 79.454 127.74 79.3726 128.149C79.2911 128.559 79.0901 128.935 78.7949 129.23C78.4997 129.525 78.1235 129.726 77.7141 129.808C77.3046 129.889 76.8802 129.847 76.4945 129.688C76.1088 129.528 75.7791 129.257 75.5471 128.91C75.3152 128.563 75.1914 128.155 75.1914 127.738C75.1914 127.178 75.4138 126.641 75.8097 126.245C76.2055 125.849 76.7424 125.627 77.3023 125.627Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.07 125.627C149.487 125.627 149.895 125.75 150.243 125.982C150.59 126.214 150.86 126.544 151.02 126.93C151.18 127.315 151.222 127.74 151.14 128.149C151.059 128.559 150.858 128.935 150.562 129.23C150.267 129.525 149.891 129.726 149.482 129.808C149.072 129.889 148.648 129.847 148.262 129.688C147.876 129.528 147.547 129.257 147.315 128.91C147.083 128.563 146.959 128.155 146.959 127.737C146.959 127.178 147.181 126.641 147.577 126.245C147.973 125.849 148.51 125.627 149.07 125.627Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3613 167.844C84.8391 162.649 89.5483 158.39 95.0714 155.444C100.595 152.498 106.761 150.957 113.024 150.957C119.287 150.957 125.454 152.498 130.977 155.444C136.5 158.39 141.209 162.649 144.687 167.844",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorDesktop);
export default __webpack_public_path__ + "static/media/error-desktop.f2bd8a9faa64d5eaa0a775c942e2263b.svg";
export { ForwardRef as ReactComponent };